import {Resource} from '../../interfaces/resource';

export function extractResource(resources: Resource[]): Resource[] {
    const idToSystemMap: Resource[] = [];

    for (const resource of resources) {
        idToSystemMap.push({id: resource.id, system: resource.system});
    }

    return idToSystemMap;
}

export function saveDataToLocalStorage(data: Resource[], resourceName: string) {
    const localStorageKey = `${resourceName}SystemArray`;
    const formattedData = extractResource(data);
    const jsonData = JSON.stringify(formattedData);

    localStorage.setItem(localStorageKey, jsonData);
}

export function findSystemById(id: string, resourceName: string) {
    const localStorageKey = `${resourceName}SystemArray`;
    const jsonData = localStorage.getItem(localStorageKey);

    if (jsonData) {
        const data = JSON.parse(jsonData);
        const item: Resource = data.find((item: {id: string}) => item.id === id);

        if (item) {
            return item.system;
        }
    }

    return '';
}
